import axiosClient from "./axiosClient.js";

const contactsDirectoryApi = {
  getFriendRequests: (body, signal) => {
    return axiosClient.post(
      "/contacts-directory/friend-requests",
      body,
      signal ? { signal } : undefined,
    );
  },
  getGroupInvitations: (body, signal) => {
    return axiosClient.post(
      "/contacts-directory/group-invitations",
      body,
      signal ? { signal } : undefined,
    );
  },
};

export default contactsDirectoryApi;
